function parseJSON(value: string) {
  try {
    return JSON.parse(value);
  } catch (error) {
    console.error(error);
    return '';
  }
}

function parseDateTime(date: Date): string {
  let newDate = new Date(date);
  newDate.setHours(newDate.getHours() + 1);
  const timeString = new Intl.DateTimeFormat('en-US', {
    minute: '2-digit',
    hour12: true,
    hour: '2-digit',
    timeZone: 'America/New_York',
    timeZoneName: 'short',
  }).format(newDate);

  const dateString = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  }).format(newDate);

  return `${timeString} on ${dateString}`;
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export { parseJSON, parseDateTime, compare };
